/**
 * TanStack Query hooks for `pentest`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	pentestQueryKeys,
	type CreatePentestBody,
	type ListPentestResponse,
	type PentestRow,
} from "./api";

export function usePentestList(): UseQueryResult<ListPentestResponse, Error> {
	return useQuery({
		queryKey: pentestQueryKeys.list(),
		queryFn: list,
	});
}

export function usePentestCreate(): UseMutationResult<PentestRow, Error, CreatePentestBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: pentestQueryKeys.all });
		},
	});
}

export function usePentestDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: pentestQueryKeys.all });
		},
	});
}
